import{default as fieldPropTypes}from"../kib-field/prop-types";const{icon,clearable,...props}=fieldPropTypes,propTypes={...props};export default propTypes;